import ChevronRightSmall from '@/icons/chevron-right-small';
import SavingsCalculator from '@/icons/savings-calculator';
import { Button } from '@/shadcn-ui/button';
import { getDynamicCurrency } from '@/util-conversion/currency';

interface SeeHowToSaveProps {
  savings: number;
  onClickDelegate: () => void;
}

export default function SeeHowToSave({ savings, onClickDelegate }: SeeHowToSaveProps) {
  return (
    <Button
      variant="clear"
      className="pointer-cursor flex h-fit w-full items-center justify-between rounded-[32px] bg-flexcar-neutral100 px-[24px] py-[28px] transition-shadow hover:shadow-shadow20 md:py-[24px]"
      onClick={onClickDelegate}
    >
      <div className="flex gap-[8px]">
        <SavingsCalculator className="flex-shrink-0" />
        <p className="body-tight leading-[22px] text-flexcar-neutral1 md:leading-[24px]">
          See how you&apos;ll{' '}
          <span className="font-semibold leading-[22px] text-flexcar-green40">
            save {getDynamicCurrency(savings)}
          </span>{' '}
          vs. buying
        </p>
      </div>
      <ChevronRightSmall className="flex-shrink-0" />
    </Button>
  );
}
